import React from 'react'
import { useTranslation } from 'react-i18next'
import { DropdownMenu, LinkButton, Button } from '@resultadosdigitais/tangram-components'
import { CaretDown } from '@resultadosdigitais/tangram-react-icons'

export const languageMapper = {
  'pt-BR': 'Português',
  'en-US': 'English',
  'es-ES': 'Español',
}

const LanguageDropdown = () => {
  const { t, i18n } = useTranslation()

  const localeUrl = locale => {
    const searchParams = window.location.search
    if (searchParams === '') {
      return `?locale=${locale}`
    }

    let urlParams = new URLSearchParams(searchParams)
    if (urlParams.get('locale') !== null) {
      urlParams.delete('locale')
    }

    if (urlParams.toString() === '') {
      return `?locale=${locale}`
    }

    return `?${urlParams.toString()}&locale=${locale}`
  }

  return (
    <DropdownMenu id="language-select">
      <DropdownMenu.Trigger>
        <Button endIcon={<CaretDown title="expand icon" titleId="caretDown" />} size={Button.sizes.md} kind={LinkButton.kinds.tertiary}>
          {languageMapper[i18n.language]}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.List>
        <DropdownMenu.Item href={localeUrl('pt-BR')} selected={i18n.language === 'pt-BR'}>
          {t('LanguageDropdown.Portuguese')}
        </DropdownMenu.Item>
        <DropdownMenu.Item href={localeUrl('es-ES')} selected={i18n.language === 'es-ES'}>
          {t('LanguageDropdown.Spanish')}
        </DropdownMenu.Item>
        <DropdownMenu.Item href={localeUrl('en-US')} selected={i18n.language === 'en-US'}>
          {t('LanguageDropdown.English')}
        </DropdownMenu.Item>
      </DropdownMenu.List>
    </DropdownMenu>
  )
}

export default LanguageDropdown
